module.exports = __webpack_public_path__ + "static/img/vip_sure_use.fb415a1.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/my/vip_sure_use.png
// module id = h07b
// module chunks = 1